import { orderMessagesNode } from '@/api/firebase'
import { async, GET_ASYNC, ASYNC_MUTATIONS } from '@/utils/async'
import { ORDER_MESSAGE_TYPE } from '@/utils/constants'

const state = {
    orderMessages: {},
    ...async()
}

const getters = {
    GET_ORDER_MESSAGES: (state) => state.orderMessages,
    GET_ASYNC
}

const mutations = {
    SET_ORDER_MESSAGE(state, payload) {
        state.orderMessages = Object.assign(
            {},
            { ...state.orderMessages },
            {
                [payload.type]: payload.messages
            }
        )
    },
    CLEAR_ORDER_MESSAGE(state) {
        state.orderMessages = {}
    },
    ...ASYNC_MUTATIONS()
}

const actions = {
    // =================================== C/U/D Operations ===================================
    // =================================== Read Operations ===================================

    /**
     * FETCH_ORDER_MESSAGE_BY_ID
     *
     *     Retrieve order messages by their type.
     *
     * @param payload.id {string} - The id of the order to retrieve messages for.
     * @returns {void}
     */
    FETCH_ORDER_MESSAGE_BY_ID({ commit }, payload) {
        commit('REQUEST')
        commit('CLEAR_ORDER_MESSAGE')
        Object.keys(ORDER_MESSAGE_TYPE).forEach((type) => {
            orderMessagesNode
                .child(payload.id)
                .child(ORDER_MESSAGE_TYPE[type])
                .on('value', (data) => {
                    commit('SET_ORDER_MESSAGE', { messages: { ...data.val() }, type: type })
                    commit('SUCCESS')
                })
        })
    },

    // =================================== Listener Operations ===================================

    /**
     * REMOVE_ORDER_MESSAGE_REFERENCE
     *
     *     Unbind a firebase connection on a child that was set.
     *
     * @param payload.id {string} - The id of the user child.
     */
    REMOVE_ORDER_MESSAGE_REFERENCE({ commit }, payload) {
        commit('CLEAR')
        commit('CLEAR_ORDER_MESSAGE')
        Object.keys(ORDER_MESSAGE_TYPE).forEach((type) => {
            orderMessagesNode
                .child(payload.id)
                .child(ORDER_MESSAGE_TYPE[type])
                .off()
        })
    }
}

export { state, getters, mutations, actions }
